<form [formGroup]="form">
  <div class="card card-body">
    <div class="row">
      <div class="col-sm-11 col-xl-6 col-xxl-4">
        <carteira-autocomplete
          #selecaoCarteiraAutocomplete
          (selectionChanged)="carteiraSelecionada($event)"
          [schema]="carteiraSchema"
        ></carteira-autocomplete>
      </div>
      <div class="col-1 mt-3">
        <button
          mat-mini-fab
          color="primary"
          type="button"
          title="Adicionar"
          [disabled]="form.invalid"
          (click)="adicionarCarteira(form.value)">
          <i class="fas fa-plus-circle" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <table class="table label-maps table-striped table-bordered table-hover table-responsive-sm">
          <thead>
            <tr>
              <th>Nome</th>
              <th class="text-center">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of getCarteirasPaging()">
              <td>{{ s.name }}</td>
              <td class="pt-1 pb-1">
                <div class="d-flex flex-row justify-content-center">
                  <button
                    mat-icon-button
                    color="warn"
                    type="button"
                    (click)="remove(s)"
                    title="Excluir">
                    <i class="fas fa-trash" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center">
          <maps-pagination
            [items]="this.associacaoService.getCarteiraPage()"
            *ngIf="
              this.associacaoService.getCarteiraPage() &&
              this.associacaoService.getCarteiraPage() > 0"
            (pageSend)="receiverPage($event)"
          ></maps-pagination>
        </div>
      </div>
    </div>
  </div>
</form>
